// extracted by mini-css-extract-plugin
module.exports = {"layout":"AppLayout_layout__1ys-v","japan":"AppLayout_japan__3SWlq","showMe":"AppLayout_showMe__2D3yC"};